import React from 'react';
import { Linkedin, Mail, Heart, Sparkles } from 'lucide-react';
import { personalInfo } from '../data/mock';

const FooterNew = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#fffcf6] border-t border-[#e0d0b8] py-12">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-bold mb-3 font-display gradient-text">
              {personalInfo.name}
            </h3>
            <p className="text-[#666666] text-sm">
              {personalInfo.title}
            </p>
            <p className="text-[#6b4226]/80 text-sm mt-2 font-handwriting text-lg">
              {personalInfo.tagline}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-[#2d2a26] font-semibold mb-4 flex items-center gap-2">
              <Sparkles className="w-4 h-4 text-[#8b5a3c]" />
              Quick Links
            </h4>
            <div className="space-y-2">
              {[
                { id: 'creations-learnings', label: 'Musings' },
                { id: 'experience', label: 'Experience' },
                { id: 'skills', label: 'Skills' },
                { id: 'education', label: 'Education' },
                { id: 'contact', label: 'Contact' }
              ].map((section) => (
                <button
                  key={section.id}
                  onClick={() => document.getElementById(section.id)?.scrollIntoView({ behavior: 'smooth' })}
                  className="block text-[#737373] hover:text-[#8b5a3c] transition-colors text-sm"
                >
                  {section.label}
                </button>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-[#2d2a26] font-semibold mb-4">Get in Touch</h4>
            <div className="space-y-3">
              <a
                href={`mailto:${personalInfo.email}`}
                className="flex items-center gap-2 text-[#737373] hover:text-[#8b5a3c] transition-colors text-sm"
              >
                <Mail className="w-4 h-4" />
                <span>Email</span>
              </a>
              <a
                href={personalInfo.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => {
                  e.preventDefault();
                  window.open(personalInfo.linkedin, '_blank', 'noopener,noreferrer');
                }}
                className="flex items-center gap-2 text-[#737373] hover:text-[#8b5a3c] transition-colors text-sm"
              >
                <Linkedin className="w-4 h-4" />
                <span>LinkedIn</span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-[#e0d0b8] flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-[#999999] text-sm">
            © {currentYear} {personalInfo.name}. All rights reserved.
          </p>
          <p className="text-[#999999] text-sm flex items-center gap-1">
            Built with <Heart className="w-4 h-4 text-[#8b5a3c]" fill="currentColor" /> and lots of caffeine
          </p>
        </div>
      </div>
    </footer>
  );
};

export default FooterNew;
